import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=d42f66ce&scoped=true"
import script from "./UiModal.vue?vue&type=script&lang=ts"
export * from "./UiModal.vue?vue&type=script&lang=ts"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=d42f66ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42f66ce",
  null
  
)

/* custom blocks */
import block0 from "./UiModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports